import { isAndroid } from '../../utils/platformUtils'
import React, { useState, useEffect } from 'react'
import { useNavigation } from '@react-navigation/native'
// import { fetchAuthSession } from 'aws-amplify/auth'
import { getAuthToken } from '../../utils/functions.utils'

import {
    StatusBar,
    StyleSheet,
    Text,
    View,
    TouchableOpacity,
    TextInput,
    Image,
    Dimensions,
    TouchableWithoutFeedback,
    ScrollView,
    ScrollViewBase,
    FlatList,
    ActivityIndicator,
    ImageBackground,
} from 'react-native'

import NetInfo from '@react-native-community/netinfo'
import { AntDesign, EvilIcons, Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import { useDeviceStore } from '../../redux/zustand/deviceInfoStore'
import styles from './GamificationGameStyles'
import { TrackingServices } from '../../../database/tracking.database'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { placeholderLearning } from '../customUtils/Constants'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import { LinearGradient } from 'expo-linear-gradient'
import {
    colorIcon,
    StepperColors,
    TriviaBackgroundColor,
    TriviaTimerAssetColor,
    TriviaTimerBorderColor,
    TriviaTheme,
    GamificationGameTheme,
} from '../../../themeConstants'
import { searchFile } from '../customUtils/Components/ImageWIthZoom'
import { openDB } from '../../db/indexDB'
import { Loader, LoaderCustomAlert } from '../customUtils/Components/Loader'
import { INPUT_TYPE } from '../../utils/Constants'
import { request_save_game } from '../../services/trivia.services'
import { getConection } from '../appBar/context/HeaderContext'
import { GamificationFinish } from './GamificationFinish'
import { useGamification } from './context/gamification.context'
import { GamificationServices } from '../../../database/gamification.database'
const { width } = Dimensions.get('window')

export default function GamificationGame({ route }) {
    const { languageFile } = getLanguage()
    const { game, level_id, pointsIfApproved } = route.params
    const navigation = useNavigation()
    const [currentQuestion, setCurrentQuestion] = useState(0)
    const [score, setScore] = useState(0)
    const [assessmentResult, setAssessmentResult] = useState({
        isApproved: false,
        totalScore: 0,
        userScorePercentage: 0,
    })
    const [showScore, setShowScore] = useState({
        show: false,
        timeOut: false,
        approved: false,
    })
    const [isLoading, setIsLoading] = useState(false)
    const [currentEvaluation, setCurrentEvaluation] = useState(null)
    const [course, setCourse] = useState(null)
    const [selectedOptions, setSelectedOptions] = useState([])

    const [database, setDatabase] = useState(null)
    const [is_connect, setConnect] = useState(false)
    const [labelComplet, setlabelComplet] = useState([]) // Estado para almacenar las respuestas del usuario en caso de complete_blanks
    const [positionLabel, setpositionLabel] = useState(null)
    const [rating, setRating] = useState(0)
    const [liked, setLiked] = useState({ active: null })
    // Obtener la evaluación al cargar el componente
    const surveyData = currentEvaluation ? currentEvaluation['questions'] : null
    const { deviceId } = useDeviceStore()
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [showInterModal, setShowInterModal] = useState(false)
    const path = game?._id ? `games/${game._id}` : null
    const DATE_START = new Date()

    const { isConnected, hasInternet } = getConection()
    const {
        updateUserLevel,
        setSelectedCategory,
        setShowRoulette,
        updateLevelAttempts,
    } = useGamification()
    const configureGame = async () => {
        let updatedGame = game
        // console.log('CONFIGURO')
        if (game.random) {
            const count = game.count ? Number(game.count) : 0
            // console.log('CANT', count)
            // console.log('QUESTIONS', game.questions.length)
            let suffledQuestions = await shuffleCuestions(
                updatedGame.questions,
                count,
            )
            updatedGame.questions = suffledQuestions
        }
        if (game.time && game.time > 0) {
            setTime(game.time)
        }
        setCurrentEvaluation(updatedGame)
    }
    const shuffleCuestions = async (questions, count) => {
        let newArray = questions
        for (let i = questions.length - 1; i > 0; i--) {
            let j = (Math.floor(Math.random() * (i + 1))[
                (newArray[i], newArray[j])
            ] = [newArray[j], newArray[i]])
        }

        newArray = newArray.map((item, index) => {
            let options = item.secondary_actions.sort(() => Math.random() - 0.5)
            // console.log('Opciones que salen', item._id + ' ===>>' + JSON.stringify(options))

            return { ...item, secondary_actions: options }
        })

        if (count > 0) {
            newArray = newArray.slice(0, count)
        }

        return newArray
    }
    useEffect(() => {
        configureGame()
    }, [game])

    const [time, setTime] = useState(null)
    const timeOut = () => {
        // console.log('TimeOut')
        // setShowScore({ show: true, timeOut: true, approved: false })
        save_evaluation(selectedOptions, true)
    }
    const handleAnswer = async (selectedAnswer) => {
        const answer = surveyData[currentQuestion]
        const questionId = answer._id

        // Verificar el tipo de pregunta
        if (
            answer.input_type.type === INPUT_TYPE.SINGLE_CHOICE ||
            answer.input_type.type === INPUT_TYPE.SINGLE_CHOICE_IMAGE
        ) {
            // Para preguntas de opción única, deselecciona todas las opciones antes de seleccionar la nueva
            const updatedQuestions = currentEvaluation.questions.map(
                (question, index) => {
                    if (index === currentQuestion) {
                        return {
                            ...question,
                            secondary_actions: question.secondary_actions.map(
                                (option) => ({
                                    ...option,
                                    is_selected: option._id === selectedAnswer._id,
                                }),
                            ),
                        }
                    }
                    return question
                },
            )

            // Actualizar el estado de la evaluación con las preguntas actualizadas
            setCurrentEvaluation({
                ...currentEvaluation,
                questions: updatedQuestions,
            })

            // Almacenar la opción seleccionada
            setSelectedOptions((prevState) => ({
                ...prevState,
                [questionId]: [selectedAnswer],
            }))
        } else {
            if (
                answer.input_type.type === INPUT_TYPE.MULTIPLE_CHOICE ||
                answer.input_type.type === INPUT_TYPE.MULTIPLE_CHOICE_IMAGE
            ) {
                // Para preguntas de opción múltiple, permite seleccionar o deseleccionar múltiples opciones
                const updatedQuestions = currentEvaluation.questions.map(
                    (question, index) => {
                        if (index === currentQuestion) {
                            return {
                                ...question,
                                secondary_actions: question.secondary_actions.map(
                                    (option) => {
                                        if (option._id === selectedAnswer._id) {
                                            // Alternar la selección de la opción
                                            return {
                                                ...option,
                                                is_selected: !option.is_selected,
                                            }
                                        }
                                        return option
                                    },
                                ),
                            }
                        }
                        return question
                    },
                )

                // Actualizar el estado de la evaluación con las preguntas actualizadas
                setCurrentEvaluation({
                    ...currentEvaluation,
                    questions: updatedQuestions,
                })

                // Obtener las opciones seleccionadas
                const selectedOptionsForQuestion = updatedQuestions[
                    currentQuestion
                ].secondary_actions.filter((option) => option.is_selected)

                // Almacenar las opciones seleccionadas
                setSelectedOptions((prevState) => ({
                    ...prevState,
                    [questionId]: selectedOptionsForQuestion,
                }))
            } else {
                // si entra aca es type input
                console.log('selectedAnswer', selectedAnswer)
                setSelectedOptions((prevState) => ({
                    ...prevState,
                    [questionId]: [{ input: selectedAnswer }],
                }))
            }
        }
    }
    let showCorrect = surveyData ? surveyData[currentQuestion]?.show_correct : false

    const [waiting, setWaiting] = useState(false)
    const [optionsToHighlight, setOptionsToHighlight] = useState([])
    const showCorrectAnswer = () => {
        setWaiting(true)
        let answeredQuestion = Object.keys(selectedOptions).find(
            (o) => o === surveyData[currentQuestion]._id,
        )

        if (answeredQuestion != undefined) {
            try {
                let options = []
                for (let q of selectedOptions[answeredQuestion]) {
                    let _id = q._id
                    options.push(_id)
                }
                setOptionsToHighlight(options)
            } catch (e) {
                console.log('Error showCorrectAnswer', e)
            }
        }
        const timer = setTimeout(() => {
            highlightTimeOut()
        }, 2000)

        return () => clearTimeout(timer)
        // console.log('OPCIONES A RESALTAR ===>', selectedOptions)
    }
    const highlightTimeOut = () => {
        setOptionsToHighlight([])
        setNextQuestion()
    }

    const handleNextQuestion = async () => {
        const answer = surveyData[currentQuestion]
        const questionId = answer._id
        const allQuestionsAnswered = selectedOptions[questionId]?.length > 0
        console.log('currentQuestion ==>', answer)
        console.log('allQuestionsAnswered ==>', allQuestionsAnswered)

        if (allQuestionsAnswered) {
            if (showCorrect) {
                showCorrectAnswer()
            } else if (answer.text_modal && answer.text_modal.length > 0) {
                setShowInterModal(true)
            } else {
                setNextQuestion()
            }
            return
        } else {
            let image = require('../../../assets/evaluations/evaluationSelectOption.png')
            let title = languageFile.select_option
            let desc = languageFile.select_one_answer
            let button = languageFile.back
            openBottomSheet(
                <BottomSheetAlert
                    image={image}
                    title={title}
                    desc={desc}
                    button={button}
                    closeBottomSheet={closeBottomSheet}
                />,
                ['50%'],
            )
            //alert('Por favor, seleccione al menos una respuesta para cada pregunta.')
        }
    }
    const setNextQuestion = async () => {
        setWaiting(false)
        setShowInterModal(false)
        const answer = surveyData[currentQuestion]
        const questionId = answer._id
        const selectedAnswer = selectedOptions[questionId][0]
        const option_selected = answer['secondary_actions'].find(
            (item) => item._id == selectedAnswer._id,
        )
        // Verificar si la respuesta redirige a otra pregunta
        if (option_selected?.go_to) {
            if (option_selected.finish) {
                save_evaluation(selectedOptions, false)
            } else {
                const nextQuestionIndex = Number(option_selected.go_to) - 1 // El índice de la próxima pregunta
                setCurrentQuestion(nextQuestionIndex) // Actualizar el estado de la pregunta actual
            }
        } else {
            if (currentQuestion + 1 >= surveyData.length) {
                save_evaluation(selectedOptions, false)
            } else {
                setCurrentQuestion(currentQuestion + 1)
            }
        }
    }

    const save_evaluation = async (answer, timeOut = false) => {
        setIsLoading(true)
        setSelectedCategory(null)
        //Check Score
        let userScore = 0
        for (let i = 0; i < currentEvaluation.questions.length; i++) {
            let { score } = validateCorrectAnswers(currentEvaluation.questions[i])
            userScore += score
        }
        let approvalRate = 0
        if (currentEvaluation.approval_rate) {
            approvalRate =
                typeof currentEvaluation.approval_rate == 'string'
                    ? parseInt(currentEvaluation.approval_rate)
                    : currentEvaluation.approval_rate
        }
        let approved = userScore >= approvalRate ? true : false
        if (approved === true) {
            let pointsToSum = pointsIfApproved || 0
            setShowRoulette(false)
            updateUserLevel(pointsToSum)
            updateLevelAttempts(level_id, true)
        } else {
            //Sumar un intento
            updateLevelAttempts(level_id)
        }
        setShowScore({ show: true, timeOut: timeOut, approved: approved })
        try {
            let parsedAnswers = await parseAnswersToSend(answer, timeOut)
            let body = {
                answers: parsedAnswers,
                date_start: DATE_START,
                date_finish: new Date(),
            }
            let status = approved ? 1 : -1
            let game_id = currentEvaluation._id

            if (isConnected && hasInternet) {
                const authToken = await getAuthToken()
                if (!authToken) return
                const data = await request_save_game({
                    authToken,
                    game_id,
                    body,
                    level_id,
                    status,
                })
            } else {
                let savePendingGame = await GamificationServices.saveGame(
                    game_id,
                    level_id,
                    status,
                    body,
                )
                console.log('🚀 ~ savePendingGame', savePendingGame)
            }
        } catch (error) {
            console.log('🚀 ~ Error sending GamificationGame', error)
            setIsLoading(false)
        } finally {
            setIsLoading(false)
        }
    }

    const ShowBottons = () => {
        return (
            <GamificationFinish
                timeOut={showScore.timeOut}
                approved={showScore.approved}
                is_connect={isConnected && hasInternet}
                exit={() => {
                    navigation.goBack()
                }}
            />
        )
    }

    const complete_blanks = (index, value) => {
        let update_option = false
        // console.log('🟢 estoy en complete_blank index:', index, 'value:', value, 'positionLabel', positionLabel, 'labelComplet:', labelComplet)
        const question = currentEvaluation.questions[currentQuestion]
        const text = question.title
        const modifiedText = text.replace(/_+/g, 'none')
        let blanks_original = modifiedText.split(' ')

        if (labelComplet.length > 0) {
            blanks_original = labelComplet
        }

        if (index !== null) {
            if (value !== '') {
                blanks_original[index] = value
            } else {
                //aca es cuando borra o selecciona donde quire  completar
                //primero deselecciono el que estaba seleccionado
                let prev_option = blanks_original[index]
                if (prev_option) {
                    console.log('🚀 ~ Survey ~ prev_option:', prev_option)
                    let find_question = question.secondary_actions.find(
                        (option) => option.label == prev_option,
                    )
                    if (find_question) {
                        // console.log('🚀 ~ =========>>> ~ find_question:', find_question)
                        selectOption(find_question._id, false)
                    }
                }
                //limpio el campo
                setpositionLabel(index)
                blanks_original[index] = 'none'
            }
        } else {
            // aca me llega el value pero no el index
            //aca no llega la posicion
            if (positionLabel !== null) {
                if (blanks_original[positionLabel]) {
                    blanks_original[positionLabel] = value.label
                    setpositionLabel(null)
                    update_option = true
                }
            } else {
                const find_index = blanks_original.indexOf('none')
                if (find_index !== -1) {
                    blanks_original[find_index] = value.label
                    update_option = true
                }
            }
        }

        // Actualiza el estado selectedOptions si es necesario
        if (update_option) {
            const selectedOptionId = value?._id
            selectOption(selectedOptionId, true)
        }

        setlabelComplet([...blanks_original])
        setSelectedOptions((prevState) => ({
            ...prevState,
            [question._id]: [...blanks_original],
        }))
    }

    const selectOption = (optionId, is_selected) => {
        const question = currentEvaluation.questions[currentQuestion]

        // Actualiza el estado is_selected de la opción seleccionada
        const updatedSecondaryActions = question.secondary_actions.map((option) => {
            if (option._id === optionId) {
                return {
                    ...option,
                    is_selected: is_selected,
                }
            }
            return option
        })

        // Actualiza el estado de la evaluación con la pregunta actualizada
        setCurrentEvaluation({
            ...currentEvaluation,
            questions: currentEvaluation.questions.map((q, index) => {
                // Solo actualiza la pregunta actual
                if (index === currentQuestion) {
                    return {
                        ...question,
                        secondary_actions: updatedSecondaryActions,
                    }
                }
                return q
            }),
        })
    }

    const validateCorrectAnswers = (question) => {
        let correctData = {
            allCorrect: false,
            score: 0,
            maxPossibleScore: 0,
        }
        if (!currentEvaluation || !question) return correctData

        correctData.allCorrect = true
        switch (question.input_type.type) {
            case INPUT_TYPE.COMPLETE_BLANKS:
                const labelCompString =
                    labelComplet.join(' ').toLocaleLowerCase() || ''
                const correctWords = question.text_correct.toLocaleLowerCase() // Respuesta correcta

                if (labelCompString != correctWords) {
                    correctData.allCorrect = false
                }
                break
            case INPUT_TYPE.SINGLE_CHOICE:
            case INPUT_TYPE.SINGLE_CHOICE_IMAGE:
            case INPUT_TYPE.MULTIPLE_CHOICE:
            case INPUT_TYPE.MULTIPLE_CHOICE_IMAGE:
                question.secondary_actions.forEach((action) => {
                    if (action.correct && !action.is_selected) {
                        correctData.allCorrect = false
                    }
                    if (action.is_selected && !action.correct) {
                        correctData.allCorrect = false
                    }
                })
                break
            default:
                console.log('Unknown question type')
                break
        }

        //? Sumo puntaje por pregunta, para el total
        correctData.maxPossibleScore = question.score ? question.score : 0

        //? Sumo puntaje solo si respondí todo bien
        if (correctData.allCorrect === true) {
            correctData.score = question.score ? question.score : 0
        }
        return correctData
    }

    let { allCorrect } = currentEvaluation
        ? validateCorrectAnswers(currentEvaluation.questions[currentQuestion])
        : false
    let modal_text = surveyData ? surveyData[currentQuestion].text_modal : ''

    const parseAnswersToSend = async (answers, timeOut) => {
        // console.log('answers', answers)
        let answersToSend = []
        Object.keys(answers).forEach((questionId) => {
            // console.log('QuesitonID', questionId)
            const question = currentEvaluation.questions.find(
                (question) => question._id === questionId,
            )
            let score = answers[questionId].reduce((sum, q) => sum + q.score, 0)
            let status = question.score == score ? 1 : -1
            let a = {
                question_id: questionId,
                questionText: question.title,
                score: status == 1 ? score : 0,
                status: status,
            }
            let optionSelectedId = []
            let optionSelectedText = []

            if (question.input_type.type === INPUT_TYPE.COMPLETE_BLANKS) {
                let selectedLabels = answers[questionId]
                const matchedOptions = selectedLabels
                    .map((label) => {
                        return question.secondary_actions.find(
                            (option) => option.label === label,
                        )
                    })
                    .filter((option) => option !== undefined)
                optionSelectedId.push(...matchedOptions.map((option) => option._id))
                optionSelectedText.push(
                    ...matchedOptions.map((option) => option.label),
                )
                // console.log('answers[questionId]', answers[questionId])
            } else {
                //Este else contempla single y multiple_choice con y sin imagen. Cambiar por switch si se agregan types
                optionSelectedId = answers[questionId].map((option) => option._id)
                optionSelectedText = answers[questionId].map(
                    (option) => option.label,
                )
            }
            a.optionSelectedId = optionSelectedId
            a.optionSelectedText = optionSelectedText
            answersToSend.push(a)
        })
        if (timeOut) {
            currentEvaluation.questions.forEach((question) => {
                if (!answers[question._id.toString()]) {
                    let a = {
                        question_id: question._id.toString(),
                        questionText: question.title,
                        score: 0,
                        status: -1,
                        optionSelectedId: [],
                        optionSelectedText: [],
                    }
                    answersToSend.push(a)
                }
            })
        }

        console.log('answersToSend => ', JSON.stringify(answersToSend))

        return answersToSend
    }
    function isPair(value) {
        return value % 2 === 0
    }
    const renderQuestionContent = () => {
        switch (currentEvaluation.questions[currentQuestion]?.input_type.type) {
            case INPUT_TYPE.MULTIPLE_CHOICE_IMAGE:
            case INPUT_TYPE.SINGLE_CHOICE_IMAGE:
                let content =
                    currentEvaluation.questions[currentQuestion]
                        ?.secondary_actions || []
                let isContentPair = isPair(content.length)
                if (!isContentPair) {
                    let ghostItem = { _id: 'ghost' }
                    content.push(ghostItem)
                }
                return (
                    <View style={styles.optionsContainer}>
                        <View style={styles.imageContainer}>
                            {content
                                .sort((a, b) =>
                                    a._id === 'ghost'
                                        ? 1
                                        : b._id === 'ghost'
                                          ? -1
                                          : 0,
                                )
                                .map((item) => {
                                    if (item._id === 'ghost') {
                                        return (
                                            <View
                                                key={item._id}
                                                style={[
                                                    styles.optionImage,
                                                    { opacity: 0 },
                                                ]}
                                            />
                                        )
                                    }
                                    let highlight = optionsToHighlight.includes(
                                        item._id,
                                    )
                                    let correctNotSelected =
                                        optionsToHighlight.length > 0 &&
                                        !optionsToHighlight.includes(item._id) &&
                                        item.correct
                                    return (
                                        <TouchableOpacity
                                            key={item._id}
                                            onPress={() => handleAnswer(item)}
                                        >
                                            <RenderImage
                                                item={item}
                                                path={path}
                                                highLight={highlight}
                                                correctNotSelected={
                                                    correctNotSelected
                                                }
                                            />
                                        </TouchableOpacity>
                                    )
                                })}
                        </View>
                    </View>
                )
            case INPUT_TYPE.COMPLETE_BLANKS:
                const question = currentEvaluation.questions[currentQuestion]
                const text = question['title']
                const modifiedText = text.replace(/_+/g, 'none')
                const blanks = modifiedText.split(' ')

                return (
                    <View style={styles.optionsContainer}>
                        <View style={styles.optionsSubContainer}>
                            {blanks.map((part, index) => {
                                return (
                                    <View
                                        key={index}
                                        style={styles.flexDirectionRow}
                                    >
                                        {part === 'none' ? (
                                            <TouchableOpacity
                                                onPress={() =>
                                                    complete_blanks(index, '')
                                                }
                                                style={
                                                    labelComplet[index]
                                                        ? labelComplet[index] !=
                                                          'none'
                                                            ? styles.complete
                                                            : styles.chip
                                                        : styles.chip
                                                }
                                            >
                                                <Text style={styles.chipText}>
                                                    {labelComplet[index]
                                                        ? labelComplet[index] !=
                                                          'none'
                                                            ? labelComplet[index]
                                                            : ''
                                                        : ''}
                                                </Text>
                                            </TouchableOpacity>
                                        ) : (
                                            <Text style={styles.optionText}>
                                                {part}{' '}
                                            </Text>
                                        )}
                                    </View>
                                )
                            })}
                        </View>

                        <View style={styles.completeBlanksContainer}>
                            {currentEvaluation?.questions[
                                currentQuestion
                            ]?.secondary_actions.map((option, optionIndex) => (
                                <TouchableOpacity
                                    key={optionIndex}
                                    onPress={() => complete_blanks(null, option)}
                                    style={[
                                        styles.optionContainer,
                                        option?.is_selected && styles.selectedOption,
                                    ]}
                                    disabled={option?.is_selected}
                                >
                                    <Text
                                        style={[
                                            styles.options,
                                            option?.is_selected &&
                                                styles.selectedOptionText,
                                        ]}
                                    >
                                        {option.label}
                                    </Text>
                                </TouchableOpacity>
                            ))}
                        </View>
                    </View>
                )

            default:
                // Renderizar las opciones para preguntas de opción única o múltiple

                const options = currentEvaluation.questions[
                    currentQuestion
                ]?.secondary_actions.map((item) => {
                    let highlight = optionsToHighlight.includes(item._id)
                    let correctNotSelected =
                        optionsToHighlight.length > 0 &&
                        !optionsToHighlight.includes(item._id) &&
                        item.correct
                    let highLightContainerStyle = item.correct
                        ? styles.highLightOptionCorrectContainer
                        : styles.highLightOptionIncorrectContainer
                    let highLightTextStyle = item.correct
                        ? styles.highLightOptionCorrectText
                        : styles.highLightOptionIncorrectText

                    return (
                        <TouchableOpacity
                            onPress={() => handleAnswer(item)}
                            style={[
                                styles.optionContainer,
                                item.is_selected && styles.selectedOption,
                                correctNotSelected &&
                                    styles.correctNotSelectedContainer,
                                highlight && highLightContainerStyle,
                            ]}
                            key={item.label}
                        >
                            <Text
                                style={[
                                    styles.options,
                                    item.is_selected && styles.selectedOptionText,
                                    correctNotSelected &&
                                        styles.correctNotSelectedText,
                                    highlight && highLightTextStyle,
                                ]}
                            >
                                {item.label}
                            </Text>
                        </TouchableOpacity>
                    )
                })

                return <View style={styles.optionsContainer}>{options}</View>
        }
    }

    return (
        <View style={styles.container}>
            {/* <StatusBar backgroundColor={TriviaTheme.triviaBackgroundColor} barStyle='light-content' /> */}
            {isLoading ? (
                <LoaderCustomAlert />
            ) : (
                <>
                    {currentEvaluation && currentEvaluation.questions ? (
                        showScore.show ? (
                            <ShowBottons />
                        ) : (
                            <ImageBackground
                                source={require('../../../assets/gamification/backgroundTriviaGamification.png')}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    pointerEvents: waiting ? 'none' : null,
                                }}
                                resizeMode='cover'
                            >
                                {/* <TouchableOpacity style={styles.backIcon} onPress={() => showBackModal()}>
                                    <Feather name='arrow-left' size={20} color={colorIcon} />
                                </TouchableOpacity> */}

                                <View
                                    style={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        marginTop: 12,
                                        marginBottom: 4,
                                        paddingHorizontal: 15,
                                        marginTop: 30 + (isAndroid() ? 12 : 45),
                                    }}
                                >
                                    <Text style={styles.titleEvaluationText}>
                                        {currentEvaluation.name ?? ''}
                                    </Text>
                                    {time && time > 0 && (
                                        <GamificationTimer
                                            time={time}
                                            timeOut={() => timeOut()}
                                            waiting={waiting}
                                        />
                                    )}
                                </View>
                                <GamificationStepper
                                    currentQuestion={currentQuestion}
                                    totalQuestions={
                                        currentEvaluation.questions.length
                                    }
                                />
                                <ScrollView showsVerticalScrollIndicator={false}>
                                    <View style={styles.parent}>
                                        <View style={styles.questionContainer}>
                                            {currentEvaluation.questions[
                                                currentQuestion
                                            ]?.input_type.type !==
                                                INPUT_TYPE.COMPLETE_BLANKS && (
                                                <View>
                                                    <Text style={styles.optionText}>
                                                        {
                                                            currentEvaluation
                                                                .questions[
                                                                currentQuestion
                                                            ]?.title
                                                        }
                                                    </Text>
                                                    {currentEvaluation.questions[
                                                        currentQuestion
                                                    ]?.media &&
                                                        currentEvaluation.questions[
                                                            currentQuestion
                                                        ]?.media != '' && (
                                                            <View
                                                                style={
                                                                    styles.container_image
                                                                }
                                                            >
                                                                <Image
                                                                    source={{
                                                                        uri: currentEvaluation
                                                                            .questions[
                                                                            currentQuestion
                                                                        ]?.media,
                                                                    }}
                                                                    style={[
                                                                        styles.optionImage,
                                                                        {
                                                                            borderWidth: 3,
                                                                            borderColor:
                                                                                'white',
                                                                        },
                                                                    ]}
                                                                />
                                                            </View>
                                                        )}
                                                </View>
                                            )}
                                            {renderQuestionContent()}
                                        </View>
                                    </View>
                                </ScrollView>
                                <TouchableOpacity
                                    onPress={() => handleNextQuestion()}
                                >
                                    <ImageBackground
                                        source={require('../../../assets/gamification/buttonTriviaGamification.png')}
                                        style={{
                                            width: width - 24,
                                            height: 60,
                                            justifyContent: 'center',
                                            alignSelf: 'center',
                                            marginBottom: 30,
                                        }}
                                        resizeMode='cover'
                                    >
                                        <Text style={styles.borderButtonText2}>
                                            {languageFile.confirm}
                                        </Text>
                                    </ImageBackground>
                                </TouchableOpacity>
                            </ImageBackground>
                        )
                    ) : (
                        <Text
                            style={[
                                { marginTop: 100 },
                                {
                                    fontSize: 20,
                                    fontWeight: 'bold',
                                    color: 'white',
                                    marginHorizontal: 15,
                                    textAlign: 'left',
                                },
                            ]}
                        >
                            {languageFile.loading_evaluation}
                        </Text>
                    )}

                    {showInterModal && (
                        <InterModal
                            name={currentEvaluation.name ?? ''}
                            correct={allCorrect}
                            text={modal_text}
                            next={() => setNextQuestion()}
                        />
                    )}
                </>
            )}
        </View>
    )
}

const RenderImage = ({ item, path, highLight, correctNotSelected }) => {
    const [newMedia, setNewMedia] = useState(item.media)

    useEffect(() => {
        const fetchMedia = async () => {
            const mediaLocal = path ? await searchFile(item.media, path) : item.media
            setNewMedia(mediaLocal)
        }
        fetchMedia()
    }, [item.media, path])
    const imageOverlay = () => {
        const selectedIcon = require('../../../assets/gamification/gamif_selected.png')
        const checkIcon = require('../../../assets/gamification/gamif_check.png')
        const wrongIcon = require('../../../assets/gamification/gamif_wrong.png')
        let overlay = null
        if (item.is_selected) {
            overlay = {
                icon: selectedIcon,
                color: GamificationGameTheme.imageSelectedIconColor,
            }
        }
        if (correctNotSelected) {
            overlay = {
                icon: checkIcon,
                color: GamificationGameTheme.imageCorrectNotSelectedIconColor,
            }
        }
        if (highLight) {
            if (item.correct) {
                overlay = {
                    icon: checkIcon,
                    color: GamificationGameTheme.imageCorrectIconColor,
                }
            } else {
                overlay = {
                    icon: wrongIcon,
                    color: GamificationGameTheme.imageIncorrectIconColor,
                }
            }
        }
        if (overlay === null) return null
        return (
            <View
                style={{
                    flex: 1,
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Image
                    source={overlay.icon}
                    style={{ width: 44, height: 44, tintColor: overlay.color }}
                />
            </View>
        )
    }
    return (
        <ImageBackground
            source={{ uri: newMedia ? newMedia : placeholderLearning }}
            style={[styles.optionImage]}
        >
            {imageOverlay()}
        </ImageBackground>
    )
}

const InterModal = ({ name, correct, text, next }) => {
    return (
        <View
            style={{
                position: 'absolute',
                backgroundColor: 'rgba(0,0,0,0.5)',
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'white',
            }}
        >
            <View style={styles.modalBox}>
                <Image
                    style={styles.IntermodalImage}
                    source={
                        correct
                            ? require('../../../assets/trivia/CheckmarkTrivia.png')
                            : require('../../../assets/trivia/errorTrivia.png')
                    }
                    resizeMode='contain'
                    resizeMethod='resize'
                />
                <Text style={styles.modalText}>{text}</Text>
                {/* <Text style={styles.modalText2}>{correct ? 'Correcto' : 'Incorrecto'}</Text> */}
                <Text style={styles.modalText2}>
                    {correct
                        ? '¡Bien hecho! 🎉 Sumaste puntos y vas por el camino correcto. Seguí así y demostrá todo tu conocimiento.'
                        : '¡Ups! 😕 No era la respuesta correcta, pero no te rindas. Aprendé de esta y preparate para la próxima pregunta. ¡Vos podés! 🚀'}
                </Text>
                <Text style={styles.modalText3}>{name}</Text>
                <TouchableOpacity onPress={() => next()}>
                    <Text style={styles.mainButton}>Siguiente</Text>
                </TouchableOpacity>
            </View>
        </View>
    )
}
const GamificationTimer = ({ time, timeOut, waiting }) => {
    const [remainingTime, setRemainingTime] = useState(time)

    useEffect(() => {
        if (waiting) return
        if (remainingTime > 0) {
            const timer = setTimeout(() => setRemainingTime(remainingTime - 1), 1000)
            return () => clearTimeout(timer)
        } else {
            timeOut()
        }
        console.log('TimeOut')
    }, [remainingTime, waiting])

    const styles = StyleSheet.create({
        timeEvaluationText: {
            fontSize: 20,
            color: 'white',
            fontWeight: 'bold',
        },
        timer: {
            width: 28,
            height: 28,
            marginEnd: 8,
        },
    })
    return (
        <View style={{ flexDirection: 'row' }}>
            <Text style={styles.timeEvaluationText}>{remainingTime}</Text>
            <Image
                source={require('../../../assets/gamification/timer.png')}
                style={styles.timer}
            />
        </View>
    )
}

const GamificationStepper = ({ currentQuestion, totalQuestions }) => {
    return (
        <View
            style={{
                flexDirection: 'row',
                marginHorizontal: 15,
                marginVertical: 20,
            }}
        >
            {[...Array(totalQuestions)].map((_, index) => (
                <View
                    key={index}
                    style={{
                        flex: 1,
                        height: 4,
                        backgroundColor:
                            currentQuestion > index
                                ? StepperColors.previousStepColor
                                : currentQuestion === index
                                  ? StepperColors.currentStepColor
                                  : StepperColors.nextStepColor,
                        marginHorizontal: 5,
                        borderRadius: 5,
                    }}
                />
            ))}
        </View>
    )
}
